import InstitutionIncorporationForm from '@/features/institution/incorporation/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingIncorporationPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="incorporation" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionIncorporationForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingIncorporationPage.displayName = 'InstitutionOnboardingIncorporationPage';

export default InstitutionOnboardingIncorporationPage;
